export default __webpack_public_path__ + "static/media/allassignments.d6a4b738.png";